import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { TenantKey } from '@/config/types'
import type { RootState } from './store'

export interface TenantState {
  tenant: TenantKey
}

const detectTenant = (userTenant?: TenantKey): TenantKey => {
  const forced = import.meta.env.VITE_FORCE_TENANT as TenantKey | undefined
  if (forced) return forced

  if (userTenant) return userTenant

  const host = window.location.hostname
  if (host.includes('blankstreet')) return 'blankstreet'
  if (host.includes('dev')) return 'dev'

  return 'dev'
}

const initialState: TenantState = {
  tenant: detectTenant(),
}

export const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setTenant: (state, action: PayloadAction<TenantKey>) => {
      state.tenant = action.payload
    },
  },
})

export const { setTenant } = tenantSlice.actions
export default tenantSlice.reducer

// ============================================================================
// SELECTORS
// ============================================================================

export const selectTenant = (state: RootState) => state.tenant.tenant
